/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";

const is = require("is_js");

const SERVICE_NAME = "EportfolioProductDetailPageService";
const log: any = LoggerModule.getInstance();

export class EportfolioProductDetailPageService {
  private static instance: EportfolioProductDetailPageService;
  private vapp: VApplication;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
  }

  public static getInstance(props: any = {}): EportfolioProductDetailPageService {
    if (!EportfolioProductDetailPageService.instance) {
      EportfolioProductDetailPageService.instance = new EportfolioProductDetailPageService(props);
    }
    return EportfolioProductDetailPageService.instance;
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async getPageContent(args: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    // const isValid = await agent.isValidNFCRead({});
    // if (!isValid) {
    //   await new Promise((r) => setTimeout(r, 4000));
    //   throw new Error("500: Bad Request");
    // }

    //HeroSection Props
    // compProps = await agent.getHeroSectionProps({});
    // if (compProps) {
    //   content = { ...content, ...compProps };
    // }

    //Attributes Props
    // compProps = await agent.getAttributesProps({});
    // if (compProps) {
    //   content = { ...content, ...compProps };
    // }

    //Carousel Props
    // compProps = await agent.getCarouselProps({});
    // if (compProps) {
    //   content = { ...content, ...compProps };
    // }

    //Description Props
    // compProps = await agent.getDescriptionProps({});
    // if (compProps) {
    //   content = { ...content, ...compProps };
    // }

    //Credential Props
    compProps = await agent.getCredentialProps({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    //ListItem Props
    // compProps = await agent.getListItemProps({});
    // if (compProps) {
    //   content = { ...content, ...compProps };
    // }

    // await new Promise((r) => setTimeout(r, 4000));
    // console.log("product Detail page content =>", content);
    return content;
  }
}
